module.exports = __webpack_public_path__ + "static/media/robVernout.52ade05a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/robVernout.jpg
// module id = 1586
// module chunks = 1